<template>
  <div>
    <display-file v-if="isFilePreview" v-bind:file="isFilePreviewData" @closePopup="closePopup"></display-file>
    <div class="d-flex flex-column">
      <main v-if="detailData" class="main-wrapper pdb-50">
        <Header :detailData="detailData" :reviewSet="reviewSet" @downloadFile="downloadSyllabus" @goToRegister="goToRegister"></Header>
        <Summary :certificateSet="certificateSet" :detailData="detailData"></Summary>
        <div class="divider"></div>
        <div class="container mgt-30">
          <SkillSet v-if="skillSet && skillSet.length > 0" :skillset="skillSet"></SkillSet>
        </div>
          <Intro v-if="!!detailData.introduction" :introduction="detailData.introduction"></Intro>
        <div class="container mgt-30">
          <Course v-if="detailData.contents && detailData.contents.length > 0" :contents="detailData.contents" @displayFile="displayFile"></Course>
          <Mission v-if="missionsList && missionsList.length > 0" :missionsList="missionsList"></Mission>
          <Certificate v-if="certificateSet" :certificateSet="certificateSet"></Certificate>
          <Tag v-if="detailData.tags.length" :tags="detailData.tags"></Tag>
          <Rating :key="reviewKey" :reviewSet="reviewSet" @reviewKeyUpdate="reviewKeyUpdate"></Rating>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import microCourseApi from "@/api/microCourseApi";
import httpService from "@/api/httpService";

export default {
  name: "MicroDegreeCourseView",

  components: {
    'top-app-bar': () => import('@/components/TopAppBar'),
    'top-app-drawer': () => import('@/components/TopAppBarDrawer'),
    'display-file': () => import('@/components/socialLearning/DisplayFile.vue'),
    Header: () => import('@/components/microDegree/view/Header.vue'),
    Summary: () => import('@/components/microDegree/view/Summary.vue'),
    SkillSet: () => import('@/components/microDegree/view/SkillSet.vue'),
    Intro: () => import('@/components/microDegree/view/Intro.vue'),
    Course: () => import('@/components/microDegree/view/Course.vue'),
    Certificate: () => import('@/components/microDegree/view/Certificate.vue'),
    Tag: () => import('@/components/microDegree/view/Tag'),
    Rating: () => import('@/components/microDegree/view/Rating.vue'),
    Mission: () => import('@/components/microDegree/view/Mission.vue')
  },

  data() {
    return {
      degreeId: this.$route.params.degreeId,
      detailData: null,
      skillSet: null,
      certificateSet: null,
      missionsList: null,
      reviewSet: null,
      isFilePreview: false,
      isFilePreviewData: null,
      reviewKey: 0
    }
  },

  created() {
    microCourseApi.courseDetail(this.degreeId).then((response) => {
      this.detailData = response.data.data;
    })

    this.fetchSkillSet();
    this.fetchCertificate();
    this.fetchMission();
    this.fetchReview();
  },

  methods: {
    goToRegister(action) {
      console.log('register action => ', action)
    },

    reviewKeyUpdate() {
      this.reviewKey += 1;
    },

    downloadSyllabus(attachment) {
      let fileName = attachment.id ? attachment.originalName : attachment.split("/").pop();
      let resourceUri = attachment.id ? attachment.resourceUri : attachment;
      httpService
          .fileDownload(resourceUri)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            console.log("error occured");
          });
    },

    fetchSkillSet() {
      microCourseApi.courseSkillSet(this.degreeId).then((response) => {
        this.skillSet = response.data.data;
      })
    },

    fetchCertificate() {
      microCourseApi.courseCertificate(this.degreeId).then((response) => {
        this.certificateSet = response.data.data;
      })
    },

    fetchReview() {
      microCourseApi.courseReview(this.$route.params.degreeId).then((response) => {
        this.reviewSet = response.data.data;
      })
    },

    fetchMission() {
      microCourseApi.courseLearningTime(this.$route.params.degreeId).then((response) => {
        this.missionsList = response.data.data;
      })
    },

    displayFile(file) {
      this.isFilePreview = true;
      this.isFilePreviewData = file;
    },

    closePopup() {
      this.isFilePriview = false;
      this.isFilePreviewData = null;
    },
  }
}
</script>

<style scoped>

</style>
